export enum DoubleRooms {
    COEFFICIENT_TWO = 2,
    COEFFICIENT_THREE = 3,
    COEFFICIENT_FIVE = 5,
    COEFFICIENT_FIFTY = 50,
}